import { useState } from "react";
import { Check } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "./Motion";
import { Gallery } from "./Gallery";
import { Lightbox } from "./Lightbox";
import { scrollToHash } from "../lib/smooth";

export const ServiceBlock = ({ s, flip }) => {
  const [active, setActive] = useState(null);
  const hasLooks = s.looks.length > 0;
  const book = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent("select-service", { detail: s.title }));
    scrollToHash("#contact");
  };

  return (
    <section id={s.id} data-testid={`service-${s.id}`} className="mx-auto max-w-[1440px] scroll-mt-24 px-5 py-20 sm:px-10 sm:py-28">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className={`min-w-0 ${hasLooks ? "lg:col-span-5" : "lg:col-span-8"} ${flip ? "lg:order-2" : ""}`}>
          <div className={hasLooks ? "lg:sticky lg:top-28" : ""}>
            <div className="flex items-baseline gap-5">
              <span className="font-display text-7xl leading-none text-[#D9CDBA] sm:text-8xl">{s.num}</span>
              <Eyebrow>{s.tag}</Eyebrow>
            </div>
            <h2 className="mt-6 font-display text-4xl leading-[1.04] sm:text-5xl">
              <MaskLines lines={[s.title]} />
            </h2>
            <Reveal delay={0.1}>
              <p className="mt-6 font-display text-2xl italic leading-snug text-[#3A3632]">{s.lead}</p>
              <p className="mt-5 text-base leading-relaxed text-[#5E5953] sm:text-lg">{s.text}</p>
              <ul className="mt-8 space-y-3 border-t border-[#E5DFD5] pt-8">
                {s.includes.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-base text-[#3A3632]">
                    <Check className="mt-1 h-4 w-4 shrink-0 text-[#A88350]" />{it}
                  </li>
                ))}
              </ul>
              <div className="mt-10 flex flex-wrap items-center gap-6">
                <a href="#contact" onClick={book} className="btn-dark" data-testid={`book-${s.id}`}>Book this service</a>
                <span className="text-sm tracking-[0.2em] uppercase text-[#6B645C]">Price on request</span>
              </div>
            </Reveal>
          </div>
        </div>
        {hasLooks && (
          <div className={`min-w-0 lg:col-span-7 ${flip ? "lg:order-1" : ""}`}>
            <Gallery looks={s.looks} id={s.id} onOpen={setActive} />
          </div>
        )}
      </div>
      {hasLooks && <Lightbox looks={s.looks} index={active} setIndex={setActive} title={s.title} id={s.id} />}
      {s.board && (
        <Reveal className="mt-16 sm:mt-24" delay={0.1}>
          <div className="flex flex-col justify-between gap-4 border-t border-[#E5DFD5] pt-8 lg:flex-row lg:items-end">
            <h3 className="font-display text-3xl leading-tight sm:text-4xl" data-testid={`board-title-${s.id}`}>{s.board.title}</h3>
            <p className="max-w-xl text-base leading-relaxed text-[#5E5953]">{s.board.note}</p>
          </div>
          <div className="mt-8 bg-[#EDE8E1]">
            <img src={s.board.src} alt={s.board.title} loading="lazy" className="mx-auto block h-auto w-full max-w-[1100px]" data-testid={`board-image-${s.id}`} />
          </div>
        </Reveal>
      )}
    </section>
  );
};
